import React from 'react'

import { colors } from 'styles/colors'

import { Desc, Title, Header, LinkNoMobile, Button } from './style'

import {
    Container,
    BenefitContainer,
    BenefitText,
    BenefitTitle,
    Content,
    BenefitsWrapper,
    ImageWrapper
} from './ProductPodFlexibleBenefits.style'

import PodTiffanyBenefits from 'assets/img/pod_benefits.png'
import PodBenefits from 'assets/svg/pod_benefits.svg'

import { flexibleBenefitsPOD } from '../../data/flexible-benefits'
import { FLAGS, useFeatureFlag } from 'components/ff4j'

const ProductPodFlexibleBenefits = () => {
    const segregecaoEnabled = useFeatureFlag(FLAGS.SEGREGACAO_CNPJ)

    const benefitsImage = segregecaoEnabled ? PodTiffanyBenefits : PodBenefits

    return (
        <Container style={{ marginTop: '40px' }}>
            <Header>
                <Title>Mais liberdade para o seu colaborador</Title>
                <Desc>
                    Oferecer o Alelo Pod como o benefício flexível da sua
                    empresa pode te ajudar com a atração e retenção de talentos
                </Desc>
            </Header>
            <Content>
                <BenefitsWrapper>
                    <ImageWrapper>
                        <img
                            src={benefitsImage}
                            alt="Benefícios do Alelo POD"
                        />
                    </ImageWrapper>
                    {flexibleBenefitsPOD.map((benefit, index) => (
                        <BenefitContainer
                            $pos={benefit.pos}
                            $index={index}
                            key={benefit.title}
                        >
                            <img src={benefit.icon} alt={benefit.text} />
                            <div>
                                <BenefitTitle>{benefit.title}</BenefitTitle>
                                <BenefitText>{benefit.text}</BenefitText>
                            </div>
                        </BenefitContainer>
                    ))}
                </BenefitsWrapper>
            </Content>
            <LinkNoMobile href="#">
                <Button
                    type="submit"
                    kind="add"
                    $background={colors.emeraldGreen}
                    $color={colors.deepPurple}
                >
                    EU QUERO
                </Button>
            </LinkNoMobile>
        </Container>
    )
}

export default ProductPodFlexibleBenefits
